import React, {FC, useEffect, useState} from "react";
import {useTypedSelector} from "../reducers";
import axios from "axios";
import {ShineDataInterface} from "../model/ShineDataInterface";
import {Link, useNavigate} from "react-router-dom";
import Select from "react-select";
import {useForm} from "react-hook-form";
import { handleError } from "../error/ErrorHandler";
import LoadPanel from "devextreme-react/load-panel";
import { UserInterface } from "../model/UserInterface";

type Props = {
    dataId: number | any;
}

const ShineRequestDetail: FC<Props> = ({dataId}) => {

    const initialSelFileList: any = [
        {value: "", label: ""}
    ]

    const initMenuInfo: ShineDataInterface = {
        dataId: 0,
        usrId: '',
        statusCd: '',
        rqstFile: '',
        rqstRsn: '',
        rjctRsn: '',
        rschPrps: '',
        rschPrd: '',
    }
    const uploadUrl = '/api/catalog/download';
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { isLogin, loginUser, status } = useTypedSelector(state => state.auth);
    const [isAdminAndPossibleToConfirm, setIsAdminAndPossibleToConfirm] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [detailContent, setDetailContent] = useState(initMenuInfo);
    const [selectedFilesStr, setSelectedFilesStr] = useState("");
    const [selectedFilesArr, setSelectedFilesArr] = useState(initialSelFileList);
    const [isRjctRsnNotEmpty, setIsRjctRsnNotEmpty] = useState(true);
    const [isRjctRsnVisible, setIsRjctRsnVisible] = useState(true);
    const [isApprove, setIsApprove] = useState(false);
    const [loading, setLoading] = useState(true);
    const [writer, setWriter] = useState<any>(null);
    const [allFiles, setAllFiles] = useState([]);


    const navigate = useNavigate();

    const getRequestDataByDataId = async () => {
        try {
            const res = await axios.get('/api/data?dataId='+ dataId);
            if (res.data) {
                setRequestWriter(res.data.usrId);
                setDetailContent(res.data);
                setIsApprove(res.data.statusCd === '2');
                setSelectedFilesStr(res.data.rqstFile);
                getSelectedFileList(res.data.rqstFile);
            }

        } catch(err) {
            handleError(err);
        }
    };

    const getAllFiles = async (catalogList: any) => {
        try {
            const fileIdList = catalogList.map( (catalog: any) => catalog.fileId).join(",");
            const res = await axios.get(`/api/file/all?fileIdList=${fileIdList}`);
            setAllFiles(res.data);
        } catch(err) {
            handleError(err);
        }
    }

    const setRequestWriter = async (usrId: string) => {
        try {
            const res = await axios.get(`/api/user/${usrId}`);
            setWriter(res.data);
            setLoading(false);
        } catch(err) {
            handleError(err);
        }
    }

    const getSelectedFileList = async (selectedFileList: string) => {
        const reqData: ShineDataInterface = {
            dataId: 0,
            usrId: '',
            statusCd: '',
            rqstFile: selectedFileList,
            rqstRsn: '',
            rjctRsn: '',
            rschPrps: '',
            rschPrd: '',
        }
        try {
            const res = await axios.post('/api/catalog/selected', reqData);
            if (res.data) {
                setSelectedFilesArr(res.data);
                if(isApprove) {
                    getAllFiles(res.data);
                }
            }
        } catch(err) {
            handleError(err);
        }
    };

    const clickConfirmBtn = (event: any) => {
        event.preventDefault();
        let result = window.confirm("데이터 신청을 승인하시겠습니까?");
        if(result){
            doConfirm();
        }
    }

    const deleteDetail = (event: any) => {
        event.preventDefault();
        let result = window.confirm('데이터 신청을 삭제하시겠습니까?');
        if (result) {
            doDelete();
        }
    }

    const clickDenyBtn = (data: any) => {
        let isRjctRsnNotNull = data.rjctRsn !== '' && data.rjctRsn !== null && data.rjctRsn !== undefined;
        if (isRjctRsnNotNull) {
            setIsRjctRsnNotEmpty(true);
            if(window.confirm("데이터 신청을 거절하시겠습니까?")) {
                doDeny(data);
            }
        } else {
            setIsRjctRsnNotEmpty(false);
        }
    };

    const doDelete = async () => {
        try {
           await axios.delete('/api/data?dataId='+ dataId);
            alert('삭제 완료했습니다.');
            navigate('/request/list');
        } catch(err) {
            handleError(err);
        }
    }

    const doConfirm = async () => {
        const data: ShineDataInterface = {
            dataId: dataId,
            usrId: '',
            statusCd: '',
            rqstFile: '',
            rqstRsn: '',
            rjctRsn: '',
            rschPrps: '',
            rschPrd: '',
        }
        try {
            await axios.put('/api/data/confirm', data);
            alert('승인 완료했습니다.');
            navigate('/request/list');
        } catch(err) {
            handleError(err);
        }
    }

    const doDeny = async (data: any) => {
        data['dataId'] = dataId;
        try {
            await axios.put('/api/data/deny', data);
            alert('거절 완료했습니다.');
            navigate('/request/list');

        } catch(err) {
            handleError(err);
        }
    }

    const isRjctRsnInputToBeVisible = () => {
        let isAdmin = isLogin && loginUser?.usrAuth === 'A';

        // 승인, 거절일 때 보이기 (admin) / 거절일때만 보이기 (!admin)
        if (isAdmin) {
            if (detailContent.statusCd === '1' || detailContent.statusCd === '3') setIsRjctRsnVisible(true)
            else setIsRjctRsnVisible(false);
        } else {
            if (detailContent.statusCd === '3') setIsRjctRsnVisible(true);
            else setIsRjctRsnVisible(false);
        }
    }

    const downloadFile = async (fileId: string) => {
        try {
            const res = await axios(`${uploadUrl}/${fileId}`, { responseType: 'blob' });
            const blob = new Blob([res.data, { type: 'application/octet-stream; UTF-8'}]);
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = decodeURIComponent(escape(res.headers['content-origin-file-name']));
            document.body.appendChild(a);
            a.click();
        } catch(err) {
            alert('권한이 없습니다.');
        }
    }

    useEffect(() => {
        if(status === 'idle') return;
        getRequestDataByDataId();
        isRjctRsnInputToBeVisible();

        // 로그인한 사용자가 어드민이면서 해당글의 상태가 '신청' 상태일 때 true
        if (isLogin && loginUser?.usrAuth === 'A' && detailContent.statusCd === '1') setIsAdminAndPossibleToConfirm(true);
        else setIsAdminAndPossibleToConfirm(false)
        setIsAdmin( isLogin && loginUser?.usrAuth === 'A');
    }, [dataId, loginUser, selectedFilesStr, isAdminAndPossibleToConfirm, isRjctRsnNotEmpty, isRjctRsnVisible]);

    return (
        <form onSubmit={handleSubmit(clickDenyBtn)}>
            <div className={'shine-request-wrapper'}>
                {loading &&
                    <LoadPanel visible={true} />
                }
                <div className={'shine-request'}>
                    <div className={'common-form-table-wrapper'}>
                        <div className={'common-form-table'}>
                            <div className={'common-form-table-header-wrapper'}>
                                <div className={'common-form-table-header-title'}>
                                </div>
                            </div>
                            <div className={'common-form-table-body-wrapper'}>
                                <div className={'common-form-table-body'}>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            연구 목적
                                        </span>
                                        <input className={'common-form-input-text lg'} value={detailContent.rschPrps} readOnly={true} />
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            연구 기간
                                        </span>
                                        <input className={'common-form-input-text lg'}  value={detailContent.rschPrd} readOnly={true} />
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            신청자명
                                        </span>
                                        <input className={'common-form-input-text lg'} value={writer?.usrNm} readOnly={true} />
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            소속기관
                                        </span>
                                        <input type={'radio'} name={'orgYn'} value={'N'} checked={writer?.orgYn === 'N'} readOnly={true} /> 개인
                                        <input className={'ml-10'} type={'radio'} value={'Y'} checked={writer?.orgYn === 'Y'} readOnly={true}/> 컨소시엄 참여 기관
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            기관명
                                        </span>
                                        <input className={'common-form-input-text lg'} value={writer?.orgNm} readOnly={true} />
                                    </label>
                                    <label className={'last'}>
                                        <span className={'common-form-input-label'}>
                                            신청한 데이터
                                        </span>
                                        <Select
                                            className="width-590
                                            css-g1d714-ValueContainer request-list
                                            css-1insrsq-control request-option1
                                            css-g1d714-ValueContainer css-1hb7zxy-IndicatorsContainer
                                            css-xb97g8 request-option3"
                                            name="filters"
                                            placeholder="데이터를 선택해주세요."
                                            value={selectedFilesArr}
                                            isDisabled={true}
                                            isMulti
                                        />
                                    </label>
                                    <label className={'last'}>
                                        <span className={'common-form-input-label'}>
                                            데이터 신청 사유
                                        </span>
                                        <textarea className={'common-form-input-textarea'} placeholder={'500자 이내'}  value={detailContent.rqstRsn} readOnly={true} />
                                    </label>
                                    {isRjctRsnVisible &&
                                    <><label className={'last'}>
                                                <span className={'common-form-input-label'}>
                                                    데이터 신청 거절 사유
                                                </span>
                                        <textarea className={'common-form-input-textarea'} placeholder={'500자 이내'}
                                                value={detailContent.rjctRsn || undefined} {...register("rjctRsn")} />
                                    </label><label className={'last no-padding-top'}>
                                        <span className={'common-form-input-label'}/>
                                        <span className={'error-msg no-margin-left'}>{isRjctRsnNotEmpty ? '' : '필수 입력값입니다.'}</span>
                                    </label></>
                                    }
                                    {isApprove && 
                                        <label className={'last'}>
                                            <span className={'common-form-input-label'}>
                                                파일 목록
                                            </span>
                                            <div>
                                                { allFiles.map( (file: any, idx: number) => {
                                                    return (
                                                        <div key={idx} className="pointer file-download" onClick={() => downloadFile(file.fileId)}>{file.fileNm}</div>
                                                    )
                                                })}
                                            </div>
                                        </label>
                                    }
                                </div>
                            </div>
                            <div className={'board-post-content-button-wrapper'}>
                                <Link className={'center-collapse'} to={'/request/list'}><button className={'common-button primary'}>목록</button></Link>
                                {isAdminAndPossibleToConfirm &&
                                <>
                                    <button className={'common-button light'} onClick={clickConfirmBtn}>승인</button>
                                    <button className={'common-button alert'} type="submit">거절</button>
                                </>
                                }
                                {isAdmin &&
                                <>
                                    <button className={'common-button alert'} onClick={deleteDetail}>삭제</button>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ShineRequestDetail
